import React, { useState, useContext} from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import VTradingContext from "../context/vTrading/VTradingContext";

import ParameterContext from "../context/parameter/parameterContext";
const VtradingDropdown = ({
  amount,
  price,
  id,
  marketPrice,
  type,
  orderType,
  orderId,
  totalInvestedForEdit,
}) => {
  const [dropDown, setDropdown] = useState(false);
  const {
    toggleVtradingAlertModal,
    setActiveCrypto,
    setActivePrice,
    setSellType,
    activeCrypto,
  } = useContext(VTradingContext);
  const { toggleVtradingModal } = useContext(ParameterContext);

  return (
    <>
      {type === "openOrder" ? (
        <div
          className="Home__MainTable-td"
          style={{ marginLeft: "10px", cursor: "pointer" }}
          onClick={() => {
            setDropdown(!dropDown);
            setActiveCrypto({ price: Number(marketPrice), symbol: id });
            setActivePrice({
              price: Number(marketPrice),
              amount: Number(amount),
              orderId: orderId,
              totalCSTAmount: Number(marketPrice) * Number(amount),
              totalInvestedForEdit,
            });
          }}
        >
          <BsThreeDotsVertical />
          {dropDown && (
            <div
              className="order__profile__transparent"
              style={{ display: "block" }}
            >
              {/* <div className="order_dropdown__triangle"></div> */}
              <div className="order_dropdown">
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    alignItems: "flexStart",
                  }}
                >
                  <li
                    onClick={() => {
                      setSellType(orderType);
                      toggleVtradingModal();
                    }}
                  >
                    Modify Order
                  </li>
                  <li
                    onClick={() => {
                      setSellType(orderType);
                      toggleVtradingAlertModal();
                    }}
                  >
                    Cancel Order
                  </li>{" "}
                </ul>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className="Home__MainTable-td"
          style={{ marginLeft: "10px", cursor: "pointer" }}
          onClick={() => {
            setDropdown(!dropDown);
            setActiveCrypto({ price: Number(marketPrice), symbol: id });
            setActivePrice({
              price: Number(marketPrice),
              amount: Number(amount),
              maxAmount: Number(amount),
              totalCSTAmount: Number(marketPrice) * Number(amount),
            });
          }}
        >
          <BsThreeDotsVertical />
          {dropDown && (
            <div
              className="order__profile__transparent"
              style={{ display: "block" }}
            >
              {/* <div className="order_dropdown__triangle"></div> */}
              <div className="order_dropdown">
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    alignItems: "flexStart",
                  }}
                >
                  <li onClick={() => toggleVtradingAlertModal()}>Sell All</li>
                  <li
                    onClick={() => {
                      setSellType("sell");
                      toggleVtradingModal();
                    }}
                  >
                    Sell by Part
                  </li>
                  <li
                    onClick={() => {
                      setSellType("buy");
                      toggleVtradingModal();
                    }}
                  >
                    Add more {activeCrypto.symbol}
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default VtradingDropdown;
